<template>
        <user-feed :selectedTab="tab" :searchText="searchText"/>
</template>

<script lang="ts">
import Vue from 'vue';
import UserFeed from '@/components/Layouts/UserFeed.vue';

export default Vue.extend({
  name: 'Home',
  props: {
    searchText: String,
    tab: String,
  },
  components: {
    UserFeed,
  },
});
</script>
